import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=296f0b0e"
import script from "./card-list.js?vue&type=script&lang=js&external"
export * from "./card-list.js?vue&type=script&lang=js&external"
import style0 from "./card-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports